
import Vue from 'vue';

import { Portal } from 'portal-vue';

class ModalOrder {
    static current = 1;
    static next(): number {
        return ModalOrder.current++;
    }
}

export default Vue.extend({
    name: 'Modal',
    components: {
        Portal,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        center: {
            // Should content be centered
            type: Boolean,
            default: false,
        },
        order: Number,
    },
    data() {
        return {
            portalOrder: 0,
            showModal: this.show,
        };
    },
    watch: {
        show: {
            immediate: true,
            handler(show: boolean) {
                if (show) {
                    this.portalOrder = this.order || ModalOrder.next();
                }
                this.$nextTick(() => {
                    this.showModal = show;
                });
            },
        },
    },
});
